import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoading = new Subject<boolean>();
  loaderState = this.isLoading.asObservable();
  private loadservice:boolean[] = [];
  get isLoader():boolean{
    return !!this.loadservice.length;
  }
  constructor() {}

  show() {
    this.loadservice.push(true);
    this.isLoading.next(!!this.loadservice.length);
  }
  hide() {
    this.loadservice.pop();
    this.isLoading.next(!!this.loadservice.length);
  }



}

